import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  OrderStore,
} from '@des/store/order';
import {
  OrderEligibilitiesStore,
} from '@des/store/order-eligibilities';
import {
  Store,
} from '@ngrx/store';
import {
  ConfigurationBaseService,
} from '@o3r/configuration';
import {
  RefundTeaserContComponent,
} from '@refx/servicing-components';

@Component({
  selector: 'custom-refund-teaser-cont',
  templateUrl: './custom-refund-teaser-cont.template.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CustomRefundTeaserContComponent extends RefundTeaserContComponent {
  constructor(protected store: Store<OrderStore & OrderEligibilitiesStore>,
    configurationService: ConfigurationBaseService) {
    super(store, configurationService);
  }
}
